import {ActionTypes} from '../Types';

export const setRoutes = (user) => (dispatch) => {
  dispatch({type: ActionTypes.SET_ROUTES});
  console.log(user);
  if (user) {
    const isAdminSystem =
      user.system?.isAdminSystem &&
      (user?.permissions?.isAdminSystem?.isActive ||
        user?.permissions?.isAdminSystemAdministrator?.isActive);

    if (
      !user.system.isBusinessIntelligence ||
      !(
        user.system.isBusinessIntelligence &&
        (user?.permissions?.isAdmin?.isActive ||
          user?.permissions?.isBusinessIntelligence?.isActive ||
          isAdminSystem)
      )
    ) {
      dispatch({
        type: ActionTypes.HIDE_TRACKING,
      });
    }
    if (!user?.permissions?.isAdmin?.isActive) {
      dispatch({
        type: ActionTypes.HIDE_USERS,
      });
    }

    if (!user.permissions?.isDeveloper?.isActive) {
      dispatch({
        type: ActionTypes.HIDE_DEV_ROUTE,
      });
    }
    if (
      user.system.isBusinessIntelligence &&
      user.permissions?.isBusinessIntelligence?.isActive &&
      !(user.permissions?.isAdmin?.isActive || isAdminSystem)
    ) {
      dispatch({
        type: ActionTypes.HIDE_BI_DETAILS,
      });
    }
  }
};
